import { useState } from 'react';
import ozonIcon from '../../../../../assets/media/icons/ozon.svg';
import { MARKETS_ALL, TYPE_BUTTONS } from '../../../../../constans';
import { Input, Select } from '../../../../../components/Basic/Inputs';
import { Row } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../components/Basic/Elements';

const MARKETS_CONTENT_MANAGER = ['OZON-2'];
const MARKETS_USERS = ['OZON-2'];
const MARKETS_ADMIN = MARKETS_ALL.ozon;

const OzonContentButton = ({ roleUser = 'content', isWarehouse = false, onClick = (_) => _ }) => {
  const [minPurchase, setMinPurchase] = useState(100);
  const [market, setMarket] = useState(MARKETS_CONTENT_MANAGER[0]);
  const [join, setJoin] = useState({ text: 'Нет', value: false });

  let list = roleUser === 'admin' || roleUser === 'owner' ? MARKETS_ADMIN : MARKETS_CONTENT_MANAGER;
  list = roleUser === 'user' ? MARKETS_USERS : list;

  return (
    <Row style={{ alignItems: 'flex-end' }}>
      {!isWarehouse && (
        <>
          <Input
            label={'Мин. закупка'}
            value={minPurchase}
            width={'80px'}
            onBlur={(v) => setMinPurchase(v)}
            style={{ marginRight: '10px' }}
          />
          <Select
            label={'Магазин'}
            select={market}
            list={list}
            onSelect={(v) => setMarket(v)}
            width={'120px'}
            style={{ marginRight: '10px' }}
          />
        </>
      )}

      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ marginLeft: '15px' }}
        onClick={() => onClick(minPurchase, market, join.value)}
      >
        <Icon src={ozonIcon} width={'25px'} style={{ marginRight: '10px' }} />
        Перенести в озон
      </Button>
    </Row>
  );
};
export default OzonContentButton;
